import React, { useState } from "react";
import styles from "./input.module.scss";
import PasteIcon from "Assets/icon/paste-icon.png";
import Select from "react-select";
import { FormGroup, Input, Label } from "reactstrap";
import { InputType } from "reactstrap/types/lib/Input";
import { useTranslation } from "lib/i18n/use-translation";

interface InputProps {
  icon?: string;
  icon2?: string | JSX.Element;
  title?: string;
  text?: string;
  className?: string;
  placeholder?: string;
  defaultText?: string;
  onTextChange?: (string) => void;
  setValue?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  setOption?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  data?: any[];
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  label?: string;
  required?: boolean;
  type?: InputType;
}

interface PrimaryInputProps extends InputProps {
  autoFocus?: boolean;
  readOnly?: boolean;
}
const PrimaryInput = ({
  type,
  icon,
  value,
  placeholder,
  onChange,
  className,
  readOnly,
  required,
  label,
  autoFocus,
  icon2,
}: PrimaryInputProps) => {
  const iconStyles = (icon || (icon && icon2)) && styles["icons"];

  const IconComponent =
    typeof icon2 === "string" ? <img src={icon2} alt="icon" /> : icon2;

  return (
    <div
      className={`sans ${styles["default-input"]} ${className} ${iconStyles} `}
    >
      {icon && <img src={icon} alt="icon" />}
      <FormGroup floating>
        {type === "file" ? (
          <Input
            type="file"
            id="wone-input"
            name="wone-input"
            onChange={onChange}
            required={required}
            autoFocus={autoFocus}
          />
        ) : (
          <Input
            value={value || ""}
            type={type}
            id="wone-input"
            name="wone-input"
            placeholder={placeholder}
            onChange={onChange}
            readOnly={readOnly}
            required={required}
            autoFocus={autoFocus}
          />
        )}

        <Label for="wone-input">{label}</Label>
      </FormGroup>
      {icon2 && IconComponent}
    </div>
  );
};

export const CopyDisplayText = ({ title, text, className }: InputProps) => {
  const { t } = useTranslation(["admin"]);
  const [isCopied, setCopied] = useState<boolean>(false);
  return (
    <div className={`sans ${styles["input"]} ${styles["copy"]} ${className}`}>
      <div className={styles["info"]}>
        <p className={`text-small ${styles["info--small"]}`}>
          {title || t("admin:input.copyFallbackTitle")}
        </p>
        <input
          defaultValue={text}
          type="text"
          id="wone-input"
          name="wone-input"
          readOnly
        />
      </div>
      <div>
        <img
          src={PasteIcon}
          alt="icon"
          onClick={async () => {
            navigator.clipboard.writeText(text).then(() => {
              setCopied(true);
              setTimeout(() => {
                setCopied(false);
              }, 2000);
            });
          }}
        />
        {isCopied && (
          <p className={`text-small ${styles["info--small"]}`}>
            {t("admin:input.copied")}
          </p>
        )}
      </div>
    </div>
  );
};

interface SearchSelectInputProps extends InputProps {
  onAutocompleteChange?: ({
    value,
    label,
  }: {
    value: string;
    label: string;
  }) => void;
  option: { value: string; label: string };
}
export const SearchSelectInput = ({
  icon,
  placeholder,
  data,
  option,
  onAutocompleteChange,
  required,
}: SearchSelectInputProps) => {
  return (
    <div className={`sans ${styles["input--select"]}`}>
      {icon && <img src={icon} alt="icon" />}
      <Select
        isSearchable
        placeholder={placeholder}
        value={option}
        onChange={onAutocompleteChange}
        options={data}
        required={required}
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            color: "#212121",
            boxShadow: state.isFocused && "0 0 0 0.25rem rgba(13,110,253,.25)",
            borderColor: state.isFocused ? "#86b7fe" : "#212121",
            "&:hover": { cursor: "pointer" },
            height: "60px",
            width: "100%",
            borderRadius: "10px",
            paddingLeft: "31px",
          }),
        }}
        /** OTHER AVAILABLE OPTIONS */
        //
        //  defaultValue={data[0]}
        // isDisabled={isDisabled}
        // isLoading={isLoading}
        // isClearable={isClearable}
        // isRtl
        // name="color"
        // isClearable
      />
    </div>
  );
};

export default PrimaryInput;
